//@ts-nocheck
import React, { useState } from 'react';
import { Modal, Select, Input, DoneRoundIcon, CloseBigIcon, DatePicker, Upload } from '@gamesb42/ui-kit';
import { Form, UploadFile } from 'antd';

import baseRequest from 'queries/baseRequest';
import { getCompanies } from 'api/company';
import CompanySelect from 'components/CompanySelect';
import Flex from 'components/Flex';
import { convertFileToBase64 } from 'helpers/file';
import { useParams } from 'react-router-dom';

import s from './styles.module.scss';

export default function AddDocModal({ onClose, getData, docTypes }) {
  const [form] = Form.useForm();
  const [docType, setDocType] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileContent, setFileContent] = useState<string | null>(null);
  const { companyId } = useParams();
  const [okDisabled, setOkDisabled] = useState(true);

  console.log(form.getFieldValue('documentFile'));

  const beforeUpload = (file: any) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target?.result as string;
      setFileContent(content);
      setFileList([...fileList, file]);

      form
        .validateFields()
        .then(() => {
          setOkDisabled(false);
        })
        .catch(() => {
          setOkDisabled(true);
        });
    };
    reader.readAsText(file);
    return false;
  };

  const handleAdd = async () => {
    try {
      const validateResult = await form.validateFields();
    } catch (e) {
      console.log(e);
      return;
    }

    const fileRaw = await convertFileToBase64(fileList[fileList.length - 1]);
    const fileSplit = fileRaw?.split(',');

    const { documentDate, documentName, documentNo, documentType, documentComment } = form.getFieldsValue();
    baseRequest({
      path: `${process.env.REACT_APP_BASE_URL}/documents/company/${companyId}`,
      options: {
        method: 'POST',
        body: JSON.stringify({
          document_type_id: documentType,
          document_name: documentName,
          document_number: documentNo,
          document_date: documentDate.format('YYYY-MM-DD'),
          document_content: fileSplit[1],
          document_comment: documentComment,
        }),
      },
    })
      .then(() => getData())
      .finally(() => {
        onClose();
      });
  };

  return (
    <Modal
      open
      title="Upload new document"
      onOk={handleAdd}
      onCancel={onClose}
      okText="Create document"
      okButtonProps={{ disabled: okDisabled, className: okDisabled ? s.okBtn : null }}
      cancelText="Cancel"
      width="838px"
    >
      <Form
        form={form}
        style={{ display: 'flex', flexDirection: 'column' }}
        onChange={async (e) => {
          try {
            await form.validateFields();
            setOkDisabled(false);
          } catch (e) {
            if (e?.errorFields?.length === 0) {
              setOkDisabled(false);
            } else {
              setOkDisabled(true);
            }
          }
        }}
      >
        <Form.Item name="documentType" rules={[{ required: true }]}>
          <Select label="Document type" size="large" options={docTypes} allowClear />
        </Form.Item>
        <Form.Item name="documentName" rules={[{ required: true }]}>
          <Input size="large" label="Document name" />
        </Form.Item>

        <Flex gap="32px">
          <Form.Item name="documentNo" rules={[{ required: true }]} style={{ width: '100%' }}>
            <Input size="large" label="Document No." />
          </Form.Item>
          <Form.Item name="documentDate" rules={[{ required: true }]} style={{ width: '100%' }}>
            <DatePicker size="large" label="Document date" />
          </Form.Item>
        </Flex>

        <Form.Item
          name="documentFile"
          rules={[
            (formInstance) => ({
              message: "'documentFile' is required",
              validator(rule, value) {
                // console.log('-->', value?.file.status === 'removed' || fileList?.length === 0);
                if (value?.file.status === 'removed' || fileList?.length === 0) {
                  return Promise.reject(new Error());
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Upload
            fileList={fileList}
            beforeUpload={beforeUpload}
            maxCount={1}
            onRemove={() => {
              form.setFieldsValue({ documentFile: undefined, error: "'documentFile' is required" });
              setFileList([]);
              setFileContent(null);
              setOkDisabled(true);
            }}
          />
        </Form.Item>

        <Form.Item name="documentComment" style={{ width: '100%' }}>
          <Input.TextArea size="large" label="Comment" showCount={false} maxLength={100} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
